import { Outlet } from "react-router";
import PanelButtonGestion from "../../../components/Button/PanelButtonGestion";
import PagePaper from "../../../components/Paper/PagePaper";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useData } from "../../../lib/context/DataContext";
import Alert from "@mui/material/Alert";
import VentePaper from "../../../components/Paper/VentePaper";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import Skeleton from "@mui/material/Skeleton";
export default function GestionVentes() {
	const { venteEnCours, prochaineVente } = useData();
	const [openAccordeon, setOpenAccordeon] = React.useState(null);

	return (
		<PagePaper name="Gestion des ventes">
			<PanelButtonGestion
				name="Ouvrir une vente"
				color="secondary"
				link="./ouvrir_vente"
				icon={<AddBusinessIcon />}
			/>
			<Outlet />

			<Stack spacing={2}>
				<Typography variant="h4">Vente en cours :</Typography>

				{!venteEnCours ? (
					<Skeleton height={75} />
				) : venteEnCours === "novente" ? (
					<Alert
						severity="info"
						color="secondary"
						sx={{
							alignItems: "center",
						}}
					>
						Aucune vente en cours cette semaine
					</Alert>
				) : (
					<VentePaper vente={venteEnCours} />
				)}
				<Typography variant="h4">Prochaine Vente :</Typography>
				{!prochaineVente ? (
					<Alert
						severity="info"
						color="secondary"
						sx={{
							alignItems: "center",
						}}
					>
						Aucune autre vente de programmé
					</Alert>
				) : (
					prochaineVente.map((nextVente) => (
						<Accordion
							key={nextVente.rowKey}
							variant="outlined"
							expanded={openAccordeon === nextVente.rowKey}
							onChange={() =>
								setOpenAccordeon((prev) =>
									prev === nextVente.rowKey
										? null
										: nextVente.rowKey
								)
							}
						>
							<AccordionSummary expandIcon={<ExpandMoreIcon />}>
								<Typography variant="h6">
									Vente{" "}
									{nextVente.rowKey
										.replace("Vente-", "")
										.replace("-2025", "")
										.replace("-", " ")}
								</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<VentePaper
									vente={nextVente}
									hideCommandes={true}
								/>
							</AccordionDetails>
						</Accordion>
					))
				)}
			</Stack>
		</PagePaper>
	);
}
